import { EnumSelect } from "@/components/shared/enum-select";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  SALES_ORDER_LOCATION_OPTIONS,
  SALES_ORDER_STATUS_OPTIONS,
  type SalesOrderSetValues,
} from "@/mocks/search-sales-orders";

interface SetValuesPanelProps {
  values: SalesOrderSetValues;
  onChange: (values: SalesOrderSetValues) => void;
  selectedCount: number;
  onClear: () => void;
}

export function SetValuesPanel({ values, onChange, selectedCount, onClear }: SetValuesPanelProps) {
  function set<K extends keyof SalesOrderSetValues>(key: K, value: SalesOrderSetValues[K]) {
    onChange({ ...values, [key]: value });
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Set — new value</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div className="grid gap-1.5">
            <Label>Status</Label>
            <EnumSelect
              value={values.status}
              onValueChange={(v) => set("status", v)}
              options={SALES_ORDER_STATUS_OPTIONS}
              allOption={{ label: "Leave unchanged" }}
              aria-label="New status"
            />
          </div>
          <div className="grid gap-1.5">
            <Label>Location</Label>
            <EnumSelect
              value={values.locationCode}
              onValueChange={(v) => set("locationCode", v)}
              options={SALES_ORDER_LOCATION_OPTIONS}
              allOption={{ label: "Leave unchanged" }}
              aria-label="New location"
            />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="so-set-ship-date">Expected ship date</Label>
            <Input
              id="so-set-ship-date"
              type="date"
              value={values.expectedShipDate}
              onChange={(e) => set("expectedShipDate", e.target.value)}
            />
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex flex-wrap items-center gap-2">
        <span title="Draft — not wired" className="inline-block">
          <Button type="button" disabled>
            Apply to selected
          </Button>
        </span>
        <Button type="button" variant="ghost" onClick={onClear}>
          Clear
        </Button>
        {selectedCount === 0 && (
          <span className="text-xs text-muted-foreground">
            Nothing selected yet — move lines into "Selected for update" first.
          </span>
        )}
      </CardFooter>
    </Card>
  );
}
